import React from 'react';
import { AlertCircle } from 'lucide-react';
interface FormFieldProps {
  label: string;
  name: string;
  error?: string;
  required?: boolean;
  children: React.ReactNode;
  description?: string;
}
export function FormField({
  label,
  name,
  error,
  required,
  children,
  description
}: FormFieldProps) {
  return <div className="mb-6" data-id="element-1">
      <label htmlFor={name} className="block text-sm font-medium text-azul-profundo mb-2" data-id="element-2">
        {label} {required && <span className="text-dorado" data-id="element-3">*</span>}
      </label>
      {description && <p className="text-sm text-gray-500 mb-2" data-id="element-4">{description}</p>}
      <div className="relative" data-id="element-5">{children}</div>
      {error && <div className="mt-2 flex items-center text-sm text-red-600" data-id="element-6">
          <AlertCircle className="w-4 h-4 mr-1 flex-shrink-0" data-id="element-7" />
          <span data-id="element-8">{error}</span>
        </div>}
    </div>;
}
export function Input({
  className = '',
  error,
  ...props
}: React.InputHTMLAttributes<HTMLInputElement> & {
  error?: boolean;
}) {
  return <input className={`w-full px-4 py-3 bg-white border-2 rounded-xl text-texto-oscuro transition-colors focus:outline-none focus:border-dorado focus:ring-1 focus:ring-dorado
        ${error ? 'border-red-500' : 'border-plateado'}
        ${className}`} {...props} data-id="element-9" />;
}
export function TextArea({
  className = '',
  error,
  ...props
}: React.TextareaHTMLAttributes<HTMLTextAreaElement> & {
  error?: boolean;
}) {
  return <textarea className={`w-full px-4 py-3 bg-white border-2 rounded-xl text-texto-oscuro transition-colors focus:outline-none focus:border-dorado focus:ring-1 focus:ring-dorado min-h-[120px] resize-y
        ${error ? 'border-red-500' : 'border-plateado'}
        ${className}`} {...props} data-id="element-10" />;
}
export function Select({
  className = '',
  error,
  children,
  ...props
}: React.SelectHTMLAttributes<HTMLSelectElement> & {
  error?: boolean;
}) {
  return <select className={`w-full px-4 py-3 bg-white border-2 rounded-xl text-texto-oscuro transition-colors focus:outline-none focus:border-dorado focus:ring-1 focus:ring-dorado appearance-none
        ${error ? 'border-red-500' : 'border-plateado'}
        ${className}`} {...props} data-id="element-11">
      {children}
    </select>;
}